
export interface CustomIcon {
  name: string;
  path: string;
}

export const CUSTOM_ICONS: CustomIcon[] =  [
  {
    name: 'accessibility',
    path: 'assets/icons/accessibility.svg',
  },
  {
    name: 'accessibility-fill',
    path: 'assets/icons/accessibility-fill.svg',
  },
  {
    name: 'task',
    path: 'assets/icons/task.svg',
  },
  {
    name: 'user-analytics',
    path: 'assets/icons/user-analytics.svg',
  },
  {
    name: 'book',
    path: 'assets/icons/book.svg',
  },
  {
    name: 'megaphone',
    path: 'assets/icons/megaphone.svg',
  },
  {
    name: 'arrow',
    path: 'assets/icons/arrow.svg',
  },
  {
    name: 'arrow-tip-down',
    path: 'assets/icons/arrow-tip-down.svg',
  },
  {
    name: 'arrow-tip-up',
    path: 'assets/icons/arrow-tip-up.svg',
  },
  {
    name: 'chevron-right',
    path: 'assets/icons/chevron-right.svg',
  },
  {
    name: 'chevron-left',
    path: 'assets/icons/chevron-left.svg',
  },
  {
    name: 'ranking-gold',
    path: 'assets/icons/ranking-gold.svg',
  },
  {
    name: 'ranking-silver',
    path: 'assets/icons/ranking-silver.svg',
  },
  {
    name: 'ranking-bronze',
    path: 'assets/icons/ranking-bronze.svg',
  },
  {
    name: 'question-circle',
    path: 'assets/icons/question-circle.svg',
  },
  {
    name: 'blackboard-arrow',
    path: 'assets/icons/blackboard-arrow.svg',
  },
  {
    name: 'book-alt-search',
    path: 'assets/icons/book-alt-search.svg',
  },
  {
    name: 'book-open',
    path: 'assets/icons/book-open.svg',
  },
  {
    name: 'book-text',
    path: 'assets/icons/book-text.svg',
  },
  {
    name: 'box',
    path: 'assets/icons/box.svg',
  },
  {
    name: 'browser-check-circle',
    path: 'assets/icons/browser-check-circle.svg',
  },
  {
    name: 'calendar-check-circle',
    path: 'assets/icons/calendar-check-circle.svg',
  },
  {
    name: 'chart-bars',
    path: 'assets/icons/chart-bars.svg',
  },
  {
    name: 'chart-pie',
    path: 'assets/icons/chart-pie.svg',
  },
  {
    name: 'check',
    path: 'assets/icons/check.svg',
  },
  {
    name: 'check-circle',
    path: 'assets/icons/check-circle.svg',
  },
  {
    name: 'clipboard',
    path: 'assets/icons/clipboard.svg',
  },
  {
    name: 'document-text-alt',
    path: 'assets/icons/document-text-alt.svg',
  },
  {
    name: 'headset',
    path: 'assets/icons/headset.svg',
  },
  {
    name: 'home',
    path: 'assets/icons/home.svg',
  },
  {
    name: 'loupe-search',
    path: 'assets/icons/loupe-search.svg',
  },
  {
    name: 'magic-wand',
    path: 'assets/icons/magic-wand.svg',
  },
  {
    name: 'money-coins',
    path: 'assets/icons/money-coins.svg',
  },
  {
    name: 'money',
    path: 'assets/icons/money.svg',
  },
  {
    name: 'paper-pen',
    path: 'assets/icons/paper-pen.svg',
  },
  {
    name: 'paper-star',
    path: 'assets/icons/paper-star.svg',
  },
  {
    name: 'report-alt',
    path: 'assets/icons/report-alt.svg',
  },
  {
    name: 'warning-triangle-solid',
    path: 'assets/icons/warning-triangle-solid.svg',
  },
  {
    name: 'warning-triangle',
    path: 'assets/icons/warning-triangle.svg',
  },
  {
    name: 'xmark',
    path: 'assets/icons/xmark.svg',
  },
  {
    name: 'user-female-circle',
    path: 'assets/icons/user-female-circle.svg',
  },
  {
    name: 'grid-dots',
    path: 'assets/icons/grid-dots.svg',
  },
  {
    name: 'menu-burger',
    path: 'assets/icons/menu-burger.svg',
  },
  {
    name: 'cancel',
    path: 'assets/icons/cancel.svg',
  },
  {
    name: 'arrow-left',
    path: 'assets/icons/arrow-left.svg',
  },
  {
    name: 'menu-dots-vertical',
    path: 'assets/icons/menu-dots-vertical.svg',
  },
  {
    name: 'face-like-square',
    path: 'assets/icons/face-like-square.svg',
  },
  {
    name: 'lock',
    path: 'assets/icons/lock.svg',
  },
  {
    name: 'sign-out',
    path: 'assets/icons/sign-out.svg',
  },
  {
    name: 'school-exam',
    path: 'assets/icons/school-exam.svg',
  },
  {
    name: 'device-notebook-chat',
    path: 'assets/icons/device-notebook-chat.svg',
  },
  {
    name: 'tools-wench-ruler',
    path: 'assets/icons/tools-wench-ruler.svg',
  },
  {
     name: 'box',
     path: 'assets/icons/box.svg',
  },
    {
     name: 'check-circle',
     path: 'assets/icons/check-circle.svg',
  },
];
